module.exports = __webpack_public_path__ + "img/training-statistics.2b1decfd.jpg";